<template>
  <div class="animate-in px-8 py-6">
    <slot />
  </div>
</template>
